import { render } from "./legend-bar.vue?vue&type=template&id=aea69f9e&scoped=true"
import script from "./legend-bar.vue?vue&type=script&lang=js"
export * from "./legend-bar.vue?vue&type=script&lang=js"

import "./legend-bar.vue?vue&type=style&index=0&id=aea69f9e&lang=scss&scoped=true"

import exportComponent from "/prodflopclient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aea69f9e"]])

export default __exports__